"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ptLocaleData = require("i18next-icu/locale-data/pt");
exports.default = ptLocaleData;
//# sourceMappingURL=pt.js.map